export { makeUpdatePreProposeConfigActionMaker } from './UpdatePreProposeConfig'
export { makeUpdateProposalConfigV1ActionMaker } from './UpdateProposalConfigV1'
export { makeUpdateProposalConfigV2ActionMaker } from './UpdateProposalConfigV2'
